"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SDKInfo =
/** @class */
function () {
  function SDKInfo(options) {
    this.productName = options.productName;
    this.version = options.version;
    this.language = options.language || 'node';
    this.platform = options.platform || 'server';
    this.headers = {
      "X-SDK-Product": this.productName,
      "X-SDK-Version": this.version,
      "X-SDK-Language": this.language,
      "X-SDK-Platform": this.platform
    };
  }

  return SDKInfo;
}();

exports.default = SDKInfo;